import List from 'app/stores/list'
import { message } from 'antd'
import { observable, action } from "mobx"
import request from 'app/vendor/request'
import config from 'app/config'
import { getToken } from "app/api/localTools"
import { timeChunk, getUrlQuery } from 'app/vendor/util'

export default class Store {
  @observable files = []
  @observable validDate = 1
  @observable linkModalShowed = false
  @observable list
  @observable exportModalShowed = false
  @observable outboundKey = ''

  @action exportDataStep1 = () => {
    return request.get(`${config.backend}/science/array-pgt/statistic/excel?outboundKey=${this.outboundKey}`)
      .query(this.list.processQueryMap)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          this.exportModalShowed = false
        }
      )
  }

  @action onInputNumberChange = (e) => {
    this.validDate = e
  }

  @action addFile = (file) => {
    if (this.files.length === 0) {
      this.files.push({
        name: file.name,
        fileObject: file,
        status: "INACTIVE",
        path: URL.createObjectURL(file),
      })
    } else {
      message.error('每次最多上传一个文件')
      return
    }
  }

  @action createNodeForDownload = (url, filed) => {
    const unique_key = url.match(/com\/(\S*)\?access_key_id/)
    const string_id = "export-a-tag" + filed + unique_key

    if (document.getElementById(string_id)) {
      document.getElementById(string_id).outerHTML = ""
    }

    let a = document.createElement("iframe")
    a.setAttribute("src", url)
    a.setAttribute("id", "export-a-tag" + filed)
    a.setAttribute("style", "display:none;")
    
    if (!document.getElementById(string_id)) {
      document.body.appendChild(a)
    }
  }

  @action uploadFiles = (type, dataType) => {
    if (this.files.length === 0) {
      message.error('请先选择要上传的文件')
      return
    }
    this.files.forEach(file => {
      if (file.status === "INACTIVE") {
        return this.uploadFile(file, type, dataType)
      }
    })
  }

  @action uploadFile = (file, type, dataType) => {
    const formData = new FormData()
    const reqType = dataType === 'results' ? 'results' : 'datas'
    const mode = dataType === 'results' ? '' : dataType

    formData.append("file", file.fileObject)
    return request.post(`${config.backend}/science/${type}/statistic/${reqType}/${this.validDate}?mode=${mode}`)
      .checkToken()
      .send(formData)
      .commonDispose()
      .then(res => {
        this.files = []
        if (dataType === 'online') {
          timeChunk(
            res,
            (url) => this.createNodeForDownload(
              url,
              dataType === 'datas' ?
                'datas' :
                'results',
            ),
            6,
            1000 * 60 * 2,
            () => this.linkModalShowed = false
          )()
        } else {
          Object.keys(res).forEach((key) => {
            const { filename } = getUrlQuery(res[key])
            this.convertBlobDownload(res[key], filename, this)
          })
        }
        return Promise.resolve(res)
      }, err => {
        this.linkModalShowed = false
        message.error(err.message)
      })
  }
  @action convertBlobDownload = (url, filename, that) => {
    let xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.setRequestHeader('Authorization', `Bearer ${getToken()}`)
    xhr.responseType = 'blob'
    xhr.onload = function () {
      if (this.status === 200) {
        that.linkModalShowed = false
        let link = document.createElement('a')
        link.download = filename
        let blob = new Blob([this.response], { type: 'text/plain'})
        link.href = URL.createObjectURL(blob)
        link.click()
        URL.revokeObjectURL(link.href)
      }
    }
    xhr.send()
  }

  @action exportConnectWebsocket = () => {
    if (!this.websocket) {
      this.websocket = new WebSocket(`${config.wsUri}/ws/statistics?jwt=${getToken()}`)
    }

    this.websocket.onopen = () => {
      // console.log('websocket oppened')
    }

    this.websocket.onmessage = (event) => {
      
      const data = JSON.parse(event.data)
      if (data && data.outboundKey) {
        this.outboundKey = data.outboundKey
      }

      if (data && data.url) {
        this.setUrl(data.url)
      }
    }

    this.websocket.onclose = (event) => {
      // console.log('websocket closed')
    }

    this.websocket.onerror = (event) => {
      const data = JSON.parse(event.data)
      if (data.code !== 200) {
        message.error(data.msg)
      }
    }
  }

  @action setUrl = (url) => {
    this.beginDownload(url)
  }

  @action closeExportWebsocket = () => {
    if (this.websocket) {
      this.websocket.close()
      this.websocket = null
    }
  }

  @action beginDownload = (url) => {
    this.exportModalShowed = false
    if (document.getElementById("export-a-tag")) document.getElementById("export-a-tag").outerHTML = ""
    let a = document.createElement("iframe")
    a.setAttribute("src", url)
    a.setAttribute("id", "export-a-tag")
    a.setAttribute("style", "display:none;")
    if (!document.getElementById("export-a-tag")) document.body.appendChild(a)
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "science/array-pgt/statistic")
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/research/arrayPgt/statistics.js